export interface PackagesPersoManagmentState {
  selectedEntities: string[];
  filter: 'all' | 'active' | 'inactive' | 'draft';
  searchTerm: string;
  pageIndex: number;
  pageSize: number;
}

export const defaultPackagesPersoManagmentState: PackagesPersoManagmentState = {
  selectedEntities: [],
  filter: 'active',
  searchTerm: '',
  pageIndex: 0,
  pageSize: 10
};

export function validatePackagesPersoManagmentState(state: any): PackagesPersoManagmentState {
  if (!state || typeof state !== 'object') {
    return { ...defaultPackagesPersoManagmentState };
  }

  return {
    selectedEntities: Array.isArray(state.selectedEntities) ? state.selectedEntities : [],
    filter: ['all', 'active', 'inactive', 'draft'].includes(state.filter) ? state.filter : 'active',
    searchTerm: typeof state.searchTerm === 'string' ? state.searchTerm : '',
    pageIndex: typeof state.pageIndex === 'number' && state.pageIndex >= 0 ? state.pageIndex : 0,
    pageSize: typeof state.pageSize === 'number' && state.pageSize > 0 ? state.pageSize : 10
  };
}